export default "__VITE_ASSET__BqwlNRGW__";